import gql from 'graphql-tag';

const GET_THROTTLE_HISTORY = gql`
  query getThrottleHistory($params: ThrottleHistoryInput!) {
    throttleHistoryByUuid(params: $params) {
      throttleHistory {
        updatedAt
        max
        min
        adjustmentReason
        adjustmentReasonDetail
        adjustmentTicketUrl
        adjustmentUpdatedBy
      }
    }
  }
`;

export default GET_THROTTLE_HISTORY;
